import { X } from 'lucide-react';
import { ATTR_CHIP_FILTRO, type ChipActivoProps } from './tipos';

// Chip de un filtro activo en la meta-row (pieza compartida, Ajuste #16;
// relevamiento de la página §4; artifact `.fchip`): el chip ENTERO es el botón
// que quita el filtro. Categoría en negrita con «:» (salvo texto libre y
// Mostrar, que se leen solos). Lleva `data-filtro-chip={key}`: lo usan la
// regla de foco de `MetaFiltros` y el harness. Reemplaza a `FilterChip` de la
// home y a `TokenChip` de la v1 cuando la home migre. El foco es el anillo
// único de la app (`:focus-visible` de index.css): hasta el 29/9 lo dibujaba a
// mano, idéntico, y figuraba en la lista blanca de guardas/anillo-unico.test.ts.

export function ChipActivo<K extends string>({ chip, onQuitar }: ChipActivoProps<K>) {
  return (
    <button
      type="button"
      {...{ [ATTR_CHIP_FILTRO]: chip.key }}
      aria-label={chip.ariaLabel}
      onClick={() => onQuitar(chip.key)}
      className="inline-flex max-w-full items-center gap-1 rounded-full bg-primary/11 py-[3px] pl-2.5 pr-1.5 text-[12px] font-[550] text-salta transition-[background-color,transform] duration-[120ms] ease-out hover:bg-primary/15 motion-safe:active:translate-y-px motion-reduce:transition-none [@media(hover:none)]:min-h-11"
    >
      <span className="min-w-0 truncate">
        {chip.cat && <b className="mr-[3px] font-[650]">{chip.cat}:</b>}
        {chip.label}
      </span>
      <X aria-hidden="true" className="size-3 flex-none opacity-80" strokeWidth={2.2} />
    </button>
  );
}
